// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3NmbF","boxTitle":"Qualiphy_boxTitle__TDzPg","box":"Qualiphy_box__2h13u","toggleWrap":"Qualiphy_toggleWrap__3xSpH"};